import EventManager from '../eventManager/EventManager'
import { addClass, removeClass } from '../helpers/DOM'
import Logger from '../helpers/Logger'
import { Adhesion } from './Adhesion'
import { Slot } from './Slot'
import { SLOT_RENDER_ATTR } from '../constants'

// Renders static and dynamic Slots
// Registers a rendered Slot to be filled
export default class SlotRenderer {
  constructor() {
    EventManager.on(
      EventManager.events.slotRenderEnded,
      this.setWidthAndHeightOnAd
    )
  }

  /**
   * Render inserts the template of a Slot instance into the DOM.
   * If the rendering did not work for any reason, it returns false.
   * Otherwise, true.
   * If a wrapper element was rendered, it assigns it to the slot instance.
   * @param slot typeof Slot
   */
  render(slot: Slot): boolean {
    if (
      !slot.validate() ||
      !slot.target ||
      !slot.insertPosition ||
      !slot.template
    ) {
      return false
    }

    slot.target.setAttribute(
      `${SLOT_RENDER_ATTR}-${slot.slotModel.adUnitId}`,
      'true'
    )
    slot.target.insertAdjacentHTML(slot.insertPosition, slot.template())
    EventManager.trigger(EventManager.events.slotWrapperRenderEnded, slot)

    return true
  }

  private setWidthAndHeightOnAd(
    event: googletag.events.SlotRenderEndedEvent,
    slot?: Slot
  ): void {
    if (!slot || !slot.wrapper) {
      Logger.debug(`No slot found during setWidthAndHeightOnAd`, event, slot)

      return
    }

    // Adhesion manages its own slotRenderEnded handler
    if (slot instanceof Adhesion) {
      return
    }

    if (event.isEmpty && slot.wrapper) {
      addClass(slot.wrapper, 'mv-empty-wrapper')
      return
    }

    if (event.size[0] > 1 && event.size[1] > 1) {
      // Set height equal to branding + adunit
      slot.wrapper.style.width = `${event.size[0]}px`
      const logoPadding = 14
      slot.wrapper.style.minHeight = `${(event.size[1] as string) +
        logoPadding}px`

      addSizeClass(event, slot.wrapper)
    }

    if (event.size[0] === 0 && event.size[1] === 0) {
      // Google Native / Fluid
      addClass(slot.wrapper, 'native') // Create container
    }

    removeClass(slot.wrapper, 'mv-empty-wrapper')
    slot.wrapper.style.display = 'block'
  }
}

export const sizeClassPrefix = `mv-size`
export function addSizeClass(
  event: { size: string | Array<number> },
  element: HTMLElement
): void {
  removeWildcardClass(sizeClassPrefix, element)
  const klass = `${sizeClassPrefix}-${event.size[0]}x${event.size[1]}`
  element.classList.add(klass)
}

export function removeWildcardClass(
  partialKlass: string,
  element: HTMLElement
): void {
  Array.from(element.classList).forEach((klass) => {
    if (klass.match(new RegExp(partialKlass, 'g'))) {
      element.classList.remove(klass)
    }
  })
}
